import ProductName from "theme/modules/ProductView/ProductName/ProductName";

export default ProductName;
